<template>
  <div class="page-container">
    <div :class="{ 'upload-data': uploadData }" class="update-container">
      <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

      <div class="content-wrapper">
        <div v-if="editObject !== null" class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <form-select
                  :input-model="editObject.year"
                  fieldname="editObject.year"
                  label="Год"
                  :input-options="yearOptions"
                  :error="validationErrors.year"
                  :error-info="errorsInfos.year ? errorsInfos.year : 'Это поле обязательно для заполнения'"
                  :server-error="serverErrors.year"
                  :keymonitor="yearChanging"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Расходы рег. оператора по обработке, обезвреживанию, захоронению отходов"
                  placeholder="Расходы рег. оператора по обработке, обезвреживанию, захоронению отходов"
                  fieldname="editObject.operating_expenses"
                  :input-model="editObject.operating_expenses"
                  :error="validationErrors.operating_expenses"
                  :error-info="
                    errorsInfos.operating_expenses ? errorsInfos.operating_expenses : 'Это поле обязательно для заполнения'
                  "
                  :server-error="serverErrors.operating_expenses"
                  :mask="inputMasks.operating_expenses"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Расходы на транспортирование ТКО"
                  placeholder="Расходы на транспортирование ТКО"
                  fieldname="editObject.transportation_expenses"
                  :input-model="
                    editObject.manual_calculation && editObject.transportation_expenses === null
                      ? 'Введите параметры ниже, значение вставится автоматически после подсчёта'
                      : editObject.transportation_expenses
                  "
                  :error="validationErrors.transportation_expenses"
                  :error-info="
                    errorsInfos.transportation_expenses
                      ? errorsInfos.transportation_expenses
                      : 'Это поле обязательно для заполнения'
                  "
                  :server-error="serverErrors.transportation_expenses"
                  :mask="editObject.manual_calculation ? {} : inputMasks.transportation_expenses"
                  :disable="editObject.manual_calculation"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <form-checkbox
                  :checked="editObject.manual_calculation"
                  label="Посчитать вручную"
                  @change="updateData({ fieldname: 'editObject.manual_calculation', value: !editObject.manual_calculation })"
                />
              </div>
              <div v-if="editObject.manual_calculation" class="col-12">
                <Input
                  label="Общая длина потоков, в км."
                  placeholder="Общая длина потоков, в км."
                  fieldname="editObject.flows_total_distance"
                  :input-model="editObject.flows_total_distance"
                  :error="validationErrors.flows_total_distance"
                  :error-info="errorsInfos.flows_total_distance ? errorsInfos.flows_total_distance : ''"
                  :server-error="serverErrors.flows_total_distance"
                  :mask="inputMasks.flows_total_distance"
                  @update="updateData"
                />
              </div>
              <div v-if="editObject.manual_calculation" class="col-12">
                <Input
                  label="Общее количество отходов, направляемых по потокам, в куб. м. / тоннах"
                  placeholder="Общее количество отходов, направляемых по потокам, в куб. м. / тоннах"
                  fieldname="editObject.flows_total_waste_volume"
                  :input-model="editObject.flows_total_waste_volume"
                  :error="validationErrors.flows_total_waste_volume"
                  :error-info="errorsInfos.flows_total_waste_volume ? errorsInfos.flows_total_waste_volume : ''"
                  :server-error="serverErrors.flows_total_waste_volume"
                  :mask="inputMasks.flows_total_waste_volume"
                  @update="updateData"
                />
              </div>
              <div v-if="editObject.manual_calculation" class="col-12">
                <Input
                  label="Стоимость перевозки 1 куб. м. / тонны отходов на 1 км"
                  placeholder="Стоимость перевозки 1 куб. м. / тонны отходов на 1 км"
                  fieldname="editObject.transportation_cost"
                  :input-model="editObject.transportation_cost"
                  :error="validationErrors.transportation_cost"
                  :error-info="
                    errorsInfos.transportation_cost ? errorsInfos.transportation_cost : 'Это поле обязательно для заполнения'
                  "
                  :server-error="serverErrors.transportation_cost"
                  :mask="inputMasks.transportation_cost"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Сбытовые расходы регионального оператора"
                  placeholder="Сбытовые расходы регионального оператора"
                  fieldname="editObject.sales_expenses"
                  :input-model="editObject.sales_expenses"
                  :error="validationErrors.sales_expenses"
                  :error-info="errorsInfos.sales_expenses ? errorsInfos.sales_expenses : 'Это поле обязательно для заполнения'"
                  :server-error="serverErrors.sales_expenses"
                  :mask="inputMasks.sales_expenses"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Расходы на заключение и обслуживание договоров с Собственниками ТКО и операторами"
                  placeholder="Расходы на заключение и обслуживание договоров с Собственниками ТКО и операторами"
                  fieldname="editObject.contracts_maintenance_expenses"
                  :input-model="editObject.contracts_maintenance_expenses"
                  :error="validationErrors.contracts_maintenance_expenses"
                  :error-info="
                    errorsInfos.contracts_maintenance_expenses
                      ? errorsInfos.contracts_maintenance_expenses
                      : 'Это поле обязательно для заполнения'
                  "
                  :server-error="serverErrors.contracts_maintenance_expenses"
                  :mask="inputMasks.contracts_maintenance_expenses"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Величина корректировки необходимой валовой выручки Регионального оператора"
                  placeholder="Величина корректировки необходимой валовой выручки Регионального оператора"
                  fieldname="editObject.revenue_correction"
                  :input-model="editObject.revenue_correction"
                  :error="validationErrors.revenue_correction"
                  :error-info="errorsInfos.revenue_correction ? errorsInfos.revenue_correction : ''"
                  :server-error="serverErrors.revenue_correction"
                  :mask="inputMasks.revenue_correction"
                  @update="updateData"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <Input
                  label="Объем отходов, транспортирование  которых будет осуществлять регоператор"
                  placeholder="Объем отходов, транспортирование  которых будет осуществлять регоператор"
                  fieldname="editObject.transportation_waste_volume"
                  :input-model="editObject.transportation_waste_volume"
                  :error="validationErrors.transportation_waste_volume"
                  :error-info="
                    errorsInfos.transportation_waste_volume
                      ? errorsInfos.transportation_waste_volume
                      : 'Одно из значений обязательно для заполнения'
                  "
                  :server-error="serverErrors.transportation_waste_volume"
                  :mask="inputMasks.transportation_waste_volume"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <Input
                  label="Масса отходов, транспортирование  которых будет осуществлять регоператор"
                  placeholder="Масса отходов, транспортирование  которых будет осуществлять регоператор"
                  fieldname="editObject.transportation_waste_weight"
                  :input-model="editObject.transportation_waste_weight"
                  :error="validationErrors.transportation_waste_weight"
                  :error-info="
                    errorsInfos.transportation_waste_weight
                      ? errorsInfos.transportation_waste_weight
                      : 'Одно из значений обязательно для заполнения'
                  "
                  :server-error="serverErrors.transportation_waste_weight"
                  :mask="inputMasks.transportation_waste_weight"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <button
                  type="button"
                  class="count-up-button"
                  :disabled="tariffFieldsValidation() ? false : true"
                  @click="countUp"
                >
                  посчитать
                </button>
              </div>
              <div class="col-6">
                <Input
                  disable
                  label="Тариф, руб. / куб. м."
                  placeholder="Тариф, руб. / куб. м."
                  fieldname="editObject.tariff_of_volume"
                  :input-model="editObject.tariff_of_volume === null ? '–' : editObject.tariff_of_volume"
                  :error="validationErrors.tariff_of_volume"
                  :error-info="errorsInfos.tariff_of_volume ? errorsInfos.tariff_of_volume : ''"
                  :server-error="serverErrors.tariff_of_volume"
                  :mask="{}"
                  @update="updateData"
                />
              </div>
              <div class="col-6">
                <Input
                  disable
                  label="Тариф, руб. / тонна"
                  placeholder="Тариф, руб. / тонна"
                  fieldname="editObject.tariff_of_weight"
                  :input-model="editObject.tariff_of_weight === null ? '–' : editObject.tariff_of_weight"
                  :error="validationErrors.tariff_of_weight"
                  :error-info="errorsInfos.tariff_of_weight ? errorsInfos.tariff_of_weight : ''"
                  :server-error="serverErrors.tariff_of_weight"
                  :mask="{}"
                  @update="updateData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import Input from "../../../../components/forms/Input";
import FormSelect from "../../../../components/forms/FormSelect";
import FormCheckbox from "../../../../components/forms/NewFormCheckbox";
import CircleLoader from "../../../../components/CircleLoader";

export default {
  name: "UpdateTariff",
  components: {
    Input,
    FormSelect,
    FormCheckbox,
    CircleLoader
  },
  data() {
    return {
      tariffYearWhenMounted: null,
      yearOptions: [],
      inputMasks: {
        operating_expenses: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        transportation_expenses: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        flows_total_distance: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        flows_total_waste_volume: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        transportation_cost: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        sales_expenses: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        contracts_maintenance_expenses: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        revenue_correction: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        transportation_waste_volume: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        transportation_waste_weight: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        tariff_of_volume: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        },
        tariff_of_weight: {
          mask: Number,
          radix: ".",
          mapToRadix: [","],
          scale: 3
        }
      }
    };
  },
  computed: {
    ...mapState("tariff", [
      "uploadData",
      "editObject",
      "validationErrors",
      "serverErrors",
      "errorsInfos",
      "fieldRequires",
      "editMode"
    ])
  },
  async mounted() {
    const { tariffId } = this.$route.params;

    this.setUploadData(true);

    await this.startEditing(tariffId);

    if (tariffId !== "new") {
      this.tariffYearWhenMounted = this.editObject.year;
    }

    const initTariffRes = await this.initTariff();
    if (initTariffRes.status === 200) {
      if (tariffId === "new") {
        this.updateEditObjectField({
          fieldName: "year",
          newFieldValue: initTariffRes.data.year === null ? null : initTariffRes.data.year
        });
        this.updateEditObjectField({
          fieldName: "flows_total_distance",
          newFieldValue: initTariffRes.data.flows_distance === null ? null : initTariffRes.data.flows_distance
        });
        this.updateEditObjectField({
          fieldName: "flows_total_waste_volume",
          newFieldValue: initTariffRes.data.wastes_volume === null ? null : initTariffRes.data.wastes_volume
        });
      }

      this.yearOptions = this.getYearOptions(initTariffRes.data.years);
    }

    this.resetValidationErrorsObject();

    this.setUploadData(false);
  },
  beforeDestroy() {
    this.setEditMode(false);
  },
  methods: {
    ...mapActions(["getSuggestion", "getSource", "getOwners"]),
    ...mapActions("tariff", ["addNewObject", "updateObject", "startEditing", "initTariff"]),
    ...mapMutations("tariff", [
      "updateEditObject",
      "updateEditObjectField",
      "updateValidationErrorsObject",
      "updateValidationErrorsField",
      "updateServerErrorsField",
      "resetValidationErrorsObject",
      "setUploadData",
      "setActiveTab",
      "setEditMode",
      "setIsOpenedFkko"
    ]),
    updateData(data) {
      const target = data.fieldname.split(".");

      if (Array.isArray(target) && target.length > 0) {
        if (target[0] === "coordinatesString") {
          this.coordinatesString = data.value;
          return;
        }

        if (target[1] === "transportation_waste_volume" || target[1] === "transportation_waste_weight") {
          ["transportation_waste_volume", "transportation_waste_weight"].map(fieldName => {
            this.updateValidationErrorsField({ fieldName: fieldName, newFieldValue: false });
            this.updateServerErrorsField({ fieldName: fieldName, newFieldValue: false });
          });
        } else {
          this.updateValidationErrorsField({ fieldName: target[1], newFieldValue: false });
          this.updateServerErrorsField({ fieldName: target[1], newFieldValue: false });
        }

        if (target[1] === "responsible_for_liquidation") {
          this.updateEditObjectField({ fieldName: target[1], newFieldValue: data.data === null ? null : data.data });
          return;
        }

        this.updateEditObjectField({ fieldName: target[1], newFieldValue: data.value === null ? null : data.value });
      }
    },
    getAutocompleteData(searchTerm, searchFieldName, restURL) {
      return this.getSource({
        url: restURL,
        params: {
          [searchFieldName]: searchTerm
        }
      }).then(res => {
        if (res.status === 200) {
          return res.data.results ? res.data.results : res.data;
        }
      });
    },
    yearChanging() {
      this.setUploadData(true);
      this.initTariff({ params: { year: this.editObject.year } }).then(res => {
        if (res.status === 200) {
          this.updateEditObjectField({
            fieldName: "flows_total_distance",
            newFieldValue: res.data.flows_distance === null ? null : res.data.flows_distance
          });
          this.updateEditObjectField({
            fieldName: "flows_total_waste_volume",
            newFieldValue: res.data.wastes_volume === null ? null : res.data.wastes_volume
          });

          this.yearOptions = this.getYearOptions(res.data.years);

          this.setUploadData(false);
        }
      });
    },
    getYearOptions(excludeYears) {
      const years = [];
      let startYear = 2000;
      const endYear = 2030;
      while (startYear <= endYear) {
        if (startYear === parseInt(this.tariffYearWhenMounted, 10) || !excludeYears.includes(startYear)) {
          years.push({ text: `${startYear}`, value: `${startYear}` });
        }
        startYear++;
      }
      return years;
    },
    tariffFieldsValidation() {
      if (
        !(
          this.isValid(this.editObject.year) &&
          this.isValid(this.editObject.operating_expenses) &&
          this.isValid(this.editObject.sales_expenses) &&
          this.isValid(this.editObject.contracts_maintenance_expenses) &&
          (this.isValid(this.editObject.transportation_waste_volume) ||
            this.isValid(this.editObject.transportation_waste_weight)) &&
          (!this.editObject.manual_calculation ||
            (this.editObject.manual_calculation &&
              this.isValid(this.editObject.flows_total_distance) &&
              this.isValid(this.editObject.flows_total_waste_volume) &&
              this.isValid(this.editObject.transportation_cost)))
        )
      ) {
        return false;
      }

      return true;
    },
    isValid(val) {
      return typeof val !== "undefined" && val !== null;
    },
    countUp() {
      if (this.editObject.manual_calculation) {
        this.updateEditObjectField({
          fieldName: "transportation_expenses",
          newFieldValue: +(
            this.editObject.flows_total_distance *
            this.editObject.flows_total_waste_volume *
            this.editObject.transportation_cost
          ).toFixed(3)
        });
      }

      this.updateEditObjectField({
        fieldName: "tariff_of_volume",
        newFieldValue:
          typeof this.editObject.transportation_waste_volume === "number" && this.editObject.transportation_waste_volume > 0
            ? +(
                (this.editObject.operating_expenses +
                  this.editObject.transportation_expenses +
                  this.editObject.sales_expenses +
                  this.editObject.contracts_maintenance_expenses +
                  this.editObject.revenue_correction) /
                this.editObject.transportation_waste_volume
              ).toFixed(3)
            : null
      });

      this.updateEditObjectField({
        fieldName: "tariff_of_weight",
        newFieldValue:
          typeof this.editObject.transportation_waste_weight === "number" && this.editObject.transportation_waste_weight > 0
            ? +(
                (this.editObject.operating_expenses +
                  this.editObject.transportation_expenses +
                  this.editObject.sales_expenses +
                  this.editObject.contracts_maintenance_expenses +
                  this.editObject.revenue_correction) /
                this.editObject.transportation_waste_weight
              ).toFixed(3)
            : null
      });
    }
  }
};
</script>
